import React from 'react'
// import ME from '../../assets/Vivek1.JPG';
import ME from '../../assets/Vivek-min2.png';
import CTA from '../header/CTA';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import "./Header1.css"
const Header1 = () => {
  return (
    <div id="home" className='intro' style={{display:'flex',paddingTop:"10rem",justifyContent:"space-around",alignContent:"center"}}>
        <div  style={{textAlign:'center'}}>
            <h5>Hello I'm</h5>
            <h1>Vivek Nemade</h1>
            <h5 className="text-light">Full-stack Web Developer</h5>
            <div className="contact__socials">
              <a href="https://www.linkedin.com/in/vivek-nemade/" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
              <a href="https://github.com/Vivek-Nemade" target="_blank" rel="noreferrer" ><FaGithub /></a>
            </div>
            <CTA/>
            
        </div>
        <div id='imgDiv'>
            <img style={{width:"250px", borderRadius:"15px"}} src={ME}alt="" />
        </div>
    </div>
  )
}

export default Header1